// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { sync } from 'vuex-router-sync';

// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';
//
// Raven
//     .config('https://c3085443f71244c0a9810d96e8fdb7c3@sentry.io/140963')
//     .addPlugin(RavenVue, Vue)
//     .install();

import App from './App';
import store from './store';
import router from './router';

sync(store, router);

// import vueSmoothScroll from 'vue-smoothscroll';
// Vue.use(vueSmoothScroll);

// comment

switch (window.location.hostname) {
  case 'localhost':
  case 'front.onlinepayment.io':
  case 'rc-front.onlinepayment.io':
  case 'dev-front.onlinepayment.io':
    window.site = {
      url: 'https://onlinepayment.io/',
      name: 'OnlinePayment.io'
    };
    break;

  case 'front.sanalposentegrasyonu.com':
  case 'dev-front.sanalposentegrasyonu.com':
    window.site = {
      url: 'https://www.sanalposentegrasyonu.com/',
      name: 'Sanal pos entegrasyonu'
    };
    break;
}

require('./lang/translation');

// TODO: is this the reason the side jumps when adding modifiers?
Vue.mixin({
  mounted () {
    if (this.scrollParent || this.$route.params.scrollParent) {
      window.scrollTo(0, 0);
      if (window.parent.postMessage) {
        window.parent.postMessage({
          id: this.$store.state.Module.iframe_id,
          type: 'scroll'
        }, '*');
      }
    }
  }
});

import * as filters from './util/filters';

import Modal from './components/Modal.vue';
Vue.component('modal', Modal);

import Spinner from './components/spinner.vue';
Vue.component('spinner', Spinner);

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// TODO: What is the reason for this?
router.beforeEach((to, from, next) => {
  if (!store.getters.initialized) {
    store.dispatch('initialize_data', to).then(() => next());
  } else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  router,
  store,
  template: '<app />',
  components: { App }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js